import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ion-padding" }

import {
  GeneralCardElements,
  LearningSession,
  LearningContextSummary,
} from "@/types";
import {
  executeLink,
  getCurrentElement,
  getCustomMessage /*, getIcon*/,
} from "@/utils";
import { IonGrid, IonRow, IonCol /*, IonIcon*/ } from "@ionic/vue";
import { PropType } from "vue";
//import { useRouter } from "vue-router";

//const $router = useRouter();

export default /*#__PURE__*/_defineComponent({
  __name: 'SessionDescription',
  props: {
  id: {
    type: String,
    required: true,
  },
  learning_context: Object as PropType<LearningContextSummary>,
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props;


let head_content: GeneralCardElements | undefined;

if (props.learning_context != undefined) {
  (
  ([__temp,__restore] = _withAsyncContext(async () => executeLink(
    "/v1/learning_sessions/" + props.id,
    async (response) => {
      head_content = await new LearningSession(response.data.data).toCard(
        undefined,
        props.learning_context,
        true,
        false
      );
    },
    () => undefined
  ))),
  await __temp,
  __restore()
);
}

return (_ctx: any,_cache: any) => {
  const _component_ionic_element = _resolveComponent("ionic-element")!

  return (_openBlock(), _createBlock(_unref(IonGrid), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), null, {
        default: _withCtx(() => [
          (_unref(head_content) != undefined)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(IonCol), { size: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ionic_element, {
                      element: _unref(head_content).title
                    }, null, 8, ["element"])
                  ]),
                  _: 1
                }),
                _createVNode(_unref(IonCol), { size: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ionic_element, {
                      element: _unref(head_content).subtitle
                    }, null, 8, ["element"])
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createBlock(_unref(IonCol), { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ionic_element, {
                    element: 
            _unref(getCustomMessage)(
              'emptiness_message',
              _unref(getCurrentElement)('non_existing_session')
            )
          
                  }, null, 8, ["element"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      (_unref(head_content) != undefined)
        ? (_openBlock(), _createBlock(_unref(IonRow), { key: 0 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(head_content).content, (element) => {
                  return (_openBlock(), _createBlock(_component_ionic_element, {
                    key: element.id,
                    element: element
                  }, null, 8, ["element"]))
                }), 128))
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})